export const RUN_HISTORY_STATUS_LABELS: Record<string, string> = {
  processing: "Processando",
  completed: "Concluída",
  failed: "Falhou",
};
